/* OneProduct EasySell Intelligent V16 — appearance only. Does not touch orders, prices, quantities or checkout. */
(()=>{
 if(window.__oneproductEsV16)return;window.__oneproductEsV16=true;
 const selectors={card:'label,[role="radio"],[class*="offer"],[class*="bundle"],[class*="quantity"],[class*="option"]'};
 const text=e=>(e?.textContent||e?.value||'').replace(/\s+/g,' ').trim().toLowerCase();
 const set=(el,styles)=>{if(!el?.style)return;for(const [k,v] of Object.entries(styles))if(v && el.style.getPropertyValue(k)!==v)el.style.setProperty(k,v,'important');};

 // Detect brand colors exclusively in the template's rendered custom Liquid content,
 // never from EasySell or unrelated page controls.
 const toHex=str=>{
   if(!str||str==='transparent')return null;
   const hex=str.trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
   if(hex){let v=hex[1];if(v.length===3)v=[...v].map(x=>x+x).join('');return '#'+v.toUpperCase();}
   const m=str.match(/^rgba?\(\s*(\d+)[, ]+\s*(\d+)[, ]+\s*(\d+)(?:[, /]+([0-9.]+))?/i);
   if(!m|| (m[4]!==undefined && Number(m[4])<.5))return null;
   return '#'+[1,2,3].map(i=>Math.max(0,Math.min(255,Number(m[i]))).toString(16).padStart(2,'0')).join('').toUpperCase();
 };
 const rgb=hex=>[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));
 const strongColor=hex=>{if(!hex)return false;const v=rgb(hex),max=Math.max(...v),min=Math.min(...v);return max-min>45&&max>65&&max<255;};
 const detectBrand=root=>{
   const counts=new Map();
   const add=(color,weight)=>{const c=toHex(color);if(strongColor(c))counts.set(c,(counts.get(c)||0)+weight);};
   for(const content of [...root.querySelectorAll('.op-liquid-content')].slice(0,3)){
     const nodes=[content,...content.querySelectorAll('*')].slice(0,350);
     for(const el of nodes){
       if(el!==content && !el.getClientRects().length)continue;
       const cs=getComputedStyle(el);
       const tag=el.tagName.toLowerCase();
       const emphasized=tag==='button'||tag==='a'||/btn|button|cta|badge|hero|highlight|brand/i.test(String(el.className||''));
       add(cs.backgroundColor,emphasized?6:2);
       add(cs.borderTopColor,emphasized?4:1);
       if(emphasized||/^h[1-6]$/.test(tag)||tag==='strong')add(cs.color,emphasized?4:2);
     }
     // CSS variables declared on the content wrappers also signal brand colors.
     for(const prop of ['--brand-color','--primary-color','--accent-color','--theme-color','--color-primary'])add(getComputedStyle(content).getPropertyValue(prop),12);
   }
   return [...counts.entries()].sort((a,b)=>b[1]-a[1])[0]?.[0]||null;
 };
 const paletteFrom=color=>{
   let hex=toHex(color)||'#008A18';
   const c=rgb(hex);
   const blend=(base,mix)=>'#'+c.map(v=>Math.round(v*(1-mix)+base*mix).toString(16).padStart(2,'0')).join('');
   const lum=(.2126*c[0]+.7152*c[1]+.0722*c[2]);
   return {btnColor:hex,btnEnd:blend(0,.18),btnText:lum>160?'#111111':'#FFFFFF',gradient:'true',selBg:blend(255,.90),selBorder:hex,selText:'#111111',selBorderWidth:'3',badgeBg:hex,badgeText:lum>160?'#111111':'#FFFFFF',offBg:'#FFFFFF',offBorder:'#D1D1D1',offBadge:blend(255,.24),titleColor:'#111111',priceColor:hex};
 };
 const lockedPalettes=new WeakMap();
 const containers=()=>[...document.querySelectorAll('.op-product-blocks')].filter(el=>el.querySelector('[data-easysell-palette]')&&el.querySelector('[data-op-es-slot]'));
 const colorDistance=(a,b)=>a&&b?Math.sqrt(rgb(a).reduce((sum,v,i)=>sum+(v-rgb(b)[i])**2,0)):999;
 const nearestOffer=(app)=>{
   const candidates=[...app.querySelectorAll('label,[role="radio"],[class*="offer"],[class*="bundle"],[class*="quantity"],[class*="option"]')].filter(el=>{
      if(!el.getClientRects().length)return false;
      const t=text(el);
      return t.length>8 && t.length<550 && /compra\s*[123456]|\b[123456]\s*x\s|pack\s*[123456]|oferta\s*[123456]/.test(t) && (/(?:q\s*|\$\s*|€\s*)\d|\d+[.,]\d\d/.test(t));
   });
   // Choose outer offer cards where possible: their immediate descendants often contain badges and prices.
   return candidates.filter(el=>!candidates.some(other=>other!==el&&el.contains(other)&&text(other).length>12));
 };
 const selected=(el)=>{
   const radio=el.querySelector('input[type="radio"],input[type="checkbox"]');
   const cs=getComputedStyle(el),border=toHex(cs.borderTopColor);
   const coloredBorder=border&&strongColor(border) && parseFloat(cs.borderTopWidth)>1;
   return el.matches('[aria-checked="true"],.selected,.active,[data-selected="true"]')||!!radio?.checked||(el.dataset.opPalettePainted!=='1'&&!!coloredBorder);
 };
 const offerBrand=(app,cards)=>{
   const counts=new Map();const add=(v,w)=>{const c=toHex(v);if(strongColor(c))counts.set(c,(counts.get(c)||0)+w)};
   for(const card of cards){
     const cs=getComputedStyle(card);
     if(selected(card)){add(cs.borderTopColor,20);add(cs.borderLeftColor,15);}
     for(const el of card.querySelectorAll('span,b,strong,small,div')){
       if(!el.getClientRects().length || el.children.length>0)continue;
       const t=text(el);if(t.length<3||t.length>70||!/ahorra|mayor ahorro|más por|descuento|gratis|más vendido|recomendado/i.test(t))continue;
       add(getComputedStyle(el).backgroundColor,10);
     }
   }
   return [...counts.entries()].sort((a,b)=>b[1]-a[1])[0]?.[0]||null;
 };
 function paint(root){
  const data=root.querySelector('[data-easysell-palette]').dataset,app=root.querySelector('[data-op-es-slot]');
  const p={...data};
  const cards=nearestOffer(app);
  if(p.mode==='auto'||p.mode==='manual'){
    // LOCKED: resolve once for a given Shopify block and its settings.
    // Never sample colors produced by this very script on subsequent renders.
    const settingsKey=[p.mode,p.brand,p.autoFallback].join('|');
    const previous=lockedPalettes.get(root);
    if(previous?.settingsKey===settingsKey){
      Object.assign(p,previous.palette);
    } else {
      const main=p.mode==='manual'?p.brand:(offerBrand(app,cards)||detectBrand(root)||p.autoFallback);
      const palette=paletteFrom(main);
      lockedPalettes.set(root,{settingsKey,palette});
      Object.assign(p,palette);
    }
  }
  const radius=(parseInt(p.radius,10)||0)+'px';
  // Only genuine EasySell order controls, never Shopify's checkout or unrelated buttons.
  const ctaText=/comprar\s*contra\s*entrega|pedido\s*contra\s*entrega|confirmar\s*(?:mi\s*)?pedido|realizar\s*pedido|order\s*now|place\s*order|finalizar\s*compra|pagar\s*al\s*recibir/i;
  const actionable='button,input[type="submit"],input[type="button"],a,[role="button"],[type="submit"],[class*="submit"],[class*="checkout"],[class*="order-btn"]';
  const ctas=new Set();
  for(const el of app.querySelectorAll(actionable)){
    if(ctaText.test(text(el))&&el.getClientRects().length&&!el.matches('[disabled],[aria-disabled="true"]'))ctas.add(el);
  }
  if(!ctas.size)for(const el of app.querySelectorAll('span,strong,b,div')){
    if(el.children.length>1||!ctaText.test(text(el))||text(el).length>90)continue;
    let candidate=el.closest(actionable);
    if(!candidate){let parent=el.parentElement;for(let i=0;i<3&&parent;i++,parent=parent.parentElement){
      if(parent.getClientRects().length&&(getComputedStyle(parent).cursor==='pointer'||parent.hasAttribute('onclick'))){candidate=parent;break;}
    }}
    if(candidate&&candidate.closest('[data-op-es-slot]')===app)ctas.add(candidate);
  }
  const bg=p.gradient==='true'?`linear-gradient(110deg,${p.btnColor},${p.btnEnd})`:p.btnColor;
  for(const btn of ctas){
    set(btn,{'background-color':p.btnColor,'background-image':p.gradient==='true'?bg:'none','color':p.btnText,'border-color':p.btnColor,'border-radius':radius});
    for(const el of btn.querySelectorAll('span,strong,b,svg,i'))if(!el.children.length||el.matches('svg'))set(el,{'color':p.btnText});
  }
  // Keep offer cards and their badges visually consistent. Never edit the real prices, variants or selected quantities.
  for(const card of cards){
    const chosen=selected(card);
    set(card,{
      'background-color':chosen?p.selBg:p.offBg,
      'background-image':chosen?`linear-gradient(145deg,${p.selBg} 0%,#FFFFFF 100%)`:'none',
      'border-color':chosen?p.selBorder:p.offBorder,
      'border-style':'solid',
      'border-width':chosen?(p.selBorderWidth+'px'):'1px',
      'border-radius':radius
    });
    card.dataset.opPalettePainted='1';
    for(const el of card.querySelectorAll('span,div,small,strong,b,p')){
      if(el.children.length>0 || !el.getClientRects().length)continue;
      const t=text(el);
      if(t.length<3||t.length>85||!/ahorra|mayor ahorro|más por|descuento|gratis|más vendido|recomendado/i.test(t))continue;
      const cs=getComputedStyle(el);
      // Only recolor labels that are already highlighted, not descriptions or white text.
      if(cs.backgroundColor==='rgba(0, 0, 0, 0)'||cs.backgroundColor==='transparent')continue;
      set(el,{'background-color':chosen?p.badgeBg:p.offBadge,'background-image':'none','color':p.badgeText,'border-radius':'5px'});
    }
  }
  if(app.querySelector('iframe')&&!ctas.size&&window.Shopify?.designMode)
    console.info('[OneProduct] El botón de EasySell está dentro de un iframe aislado: debe colorearse desde EasySell.');
 }
 let busy=false;const refresh=()=>{if(busy)return;busy=true;requestAnimationFrame(()=>{busy=false;containers().forEach(paint);});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
 const observer=new MutationObserver(records=>{if(records.some(r=>r.type==='childList'&&(r.addedNodes.length||r.removedNodes.length)))refresh();});
 observer.observe(document.documentElement,{subtree:true,childList:true});
 document.addEventListener('change',e=>{if(e.target.closest('[data-op-es-slot]'))refresh()},true);
 document.addEventListener('click',e=>{if(e.target.closest('[data-op-es-slot]'))requestAnimationFrame(refresh)},true);
 document.addEventListener('shopify:section:load',refresh);
 document.addEventListener('shopify:block:select',refresh);
 document.addEventListener('shopify:section:select',refresh);
 // Respond to palette data-* mutations without observing app styles (which we change ourselves).
 const paletteObserver=new MutationObserver(records=>{
   if(records.some(r=>r.type==='attributes'&&r.attributeName?.startsWith('data-')))refresh();
 });
 const observePalettes=()=>document.querySelectorAll('[data-easysell-palette]').forEach(el=>{
   if(el.dataset.opPaletteObserved==='1')return;
   el.dataset.opPaletteObserved='1';
   paletteObserver.observe(el,{attributes:true});
 });
 observePalettes();
 const originalRefresh=refresh;
 // Shopify may replace palette blocks while editing; watch added nodes to bind again.
 const paletteMountObserver=new MutationObserver(records=>{
   if(records.some(r=>r.type==='childList'&&r.addedNodes.length))observePalettes();
 });
 paletteMountObserver.observe(document.documentElement,{childList:true,subtree:true});

})();